<template>
  <div class="relative-container">
    <template v-if="listView">
      <div :class="{'list-view-filters container': isFromDashboard}">
        <list-view-header v-if="hasFilters || isFormability" :listView="listView"></list-view-header>

        <div v-if="isFromDashboard">
          <dashboard-drilldown-filters/>
        </div>
      </div>

      <div class="c-row container justify-content-between">
        <list-view-table-meta-links
          class="mx-0"
          :total-count="objectModelEntriesTotalCount"
          :show-view-all="false"
          :show-connected-text="opts.showConnectedText"
        ></list-view-table-meta-links>

        <p v-if="hasFilters" class="desc">
          <button type="button" class="btn-link" @click="clearQueryFilters">
            Clear all filters
          </button>
        </p>
      </div>

      <list-view-scrollable-table
        :listView="listView"
        :is-embedded="false"
        :entries="entries"
        :has-filters="hasFilters"
        :preview="preview"
      ></list-view-scrollable-table>
    </template>
  </div>
</template>
  
<script lang="ts">
import Vue from "vue";
import ListViewHeader from "./list-view-header.vue";
import ListViewScrollableTable from "./list-view-scrollable-table.vue";
import ListView from "../../../common/models/listViews/listView";
import PublishedListView from "../../../common/models/listViews/publishedListView";
import ObjectModelFakeEntry from "~/models/objectModelEntries/objectModelFakeEntry";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import HideListViewBus from "../buses/hideListViewBus";
import ListViewTableMetaLinks from "./list-view-table-meta-links.vue";
import {mapState} from "vuex";
import Pill from "~/components/pill.vue"
import DashboardDrilldownFilters from "~/components/visualizations/dashboard-drilldown-filters.vue"
import dashboardDrilldownFiltersMixin from "../mixins/dashboardDrilldownFiltersMixin";
import BuilderIconActions from "~/components/builders/builderIconActions.vue";
import RouterMixin from "~/mixins/routerMixin";
import ClearListViewFiltersEventBus from "../buses/clearListViewFiltersEventBus";

export default Vue.extend({
  components: {
    BuilderIconActions,
    ListViewTableMetaLinks,
    ListViewHeader,
    ListViewScrollableTable,
    Pill,
    DashboardDrilldownFilters,
  },
  mixins: [
    dashboardDrilldownFiltersMixin,
    RouterMixin,
  ],
  props: {
    listView: {
      type: Object as () => ListView | PublishedListView,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    opts: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      hideWhileSearching: false,
    }
  },
  computed: {
    hasFilters(): boolean {
      return this.listView.filterElementsArray.length > 0;
    },
    isFromDashboard(): boolean {
      return this.$router.currentRoute.query['from_dashboard_id'];
    },
    entries(): Array<ObjectModelEntry | ObjectModelFakeEntry> {
      const model = this.preview ? ObjectModelFakeEntry : ObjectModelEntry;
      if (this.hideWhileSearching) {
        return [];
      } else {
        return model.repo.all();
      }
    },

    ...mapState('objectModelEntriesStore', ['objectModelEntriesTotalCount'])
  },
  methods: {
    clearQueryFilters(): void {
      ClearListViewFiltersEventBus.emitEvent();
    },
  },
  mounted() {
    HideListViewBus.$on('hideWhileSearching', (payload: boolean) => this.hideWhileSearching = payload)
  },
});
</script>
